import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import unescapedText from 'I18n/utils/unescapedText';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled from 'foundations-theming/utils';
import { SideNavContextProvider } from './SideNavContext';
import { View } from '../../../components/View';
import { HR } from '../HR/HR';
import { H5 } from '../H5/H5';
import { Children } from 'react';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUl = styled.ul.withConfig({
  displayName: "SideNav__StyledUl"
})(({
  depth,
  theme
}) => {
  return {
    listStyle: 'none',
    paddingLeft: 0,
    marginTop: theme.space['0'],
    lineHeight: theme.typography['detail-200'].lineHeight,
    marginBottom: depth === 0 ? 0 : undefined
  };
});
const StyledNav = styled.nav.withConfig({
  displayName: "SideNav__StyledNav"
})(({
  $cssStyles,
  theme,
  $divider
}) => {
  return Object.assign({}, $cssStyles, !$divider && {
    '&:not(:first-of-type)': {
      marginBlockStart: theme.space['800']
    }
  });
});
export const SideNav = _ref => {
  let {
      'aria-label': ariaLabel,
      activeVariant = 'default',
      children,
      depth = 0,
      divider = false,
      headingText,
      value,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["aria-label", "activeVariant", "children", "depth", "divider", "headingText", "value", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  const isTopLevelNav = depth === 0;
  const computedAriaLabel = ariaLabel || headingText || unescapedText('ui.UISideNav.navigationLandmark');
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(SideNavContextProvider, {
    depth: depth,
    value: value,
    activeVariant: activeVariant,
    children: [divider && /*#__PURE__*/_jsx(View, {
      paddingBlockEnd: "200",
      children: /*#__PURE__*/_jsx(HR, {
        distance: "sm",
        backgroundColor: "border-core-subtle"
      })
    }), /*#__PURE__*/_jsxs(StyledNav, Object.assign({
      "aria-label": computedAriaLabel,
      as: isTopLevelNav ? 'nav' : 'div'
    }, domProps, {
      $cssStyles: cssStyles,
      $divider: divider,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'SideNav',
      children: [headingText && /*#__PURE__*/_jsx(View, {
        paddingBlockEnd: "200",
        children: /*#__PURE__*/_jsx(H5, {
          margin: "0",
          children: headingText
        })
      }), /*#__PURE__*/_jsx(StyledUl, {
        depth: depth,
        children: Children.map(children, child => {
          if (!child) {
            return null;
          }
          return child;
        })
      })]
    }))]
  });
};
SideNav.displayName = 'SideNav';